// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.sinohope",
    name: "Sinohope",
    homepage: "https://www.sinohope.com/",
    image_id: "06d056b9-aba7-453c-ddaf-a077a448ea00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/app/sinohope-hotgroup-wallet/id1672956199",
        android: "https://play.google.com/store/apps/details?id=com.sinohope.mpcwallet.app",
        mac: "",
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "sinohopeapp://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map